const isUnauthorizedError = (err) => (!!err && err.statusCode === 401)

export default isUnauthorizedError
